import { render, staticRenderFns } from "./listEmails.vue?vue&type=template&id=2c50c87c&"
import script from "./listEmails.vue?vue&type=script&lang=js&"
export * from "./listEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports